// extracted by mini-css-extract-plugin
export default {"grid":"card2_grid__15p4R","gridItem":"card2_gridItem__Hyobe","image":"card2_image__BbFsw"};